export default "__VITE_ASSET__CNjJ9Iav__"